import { Stack } from "@chakra-ui/react";
import { McpUsageHistory, McpUsageSummary } from "./components";

const McpUsage = ({ companyId }: { companyId: number }) => (
  <Stack spacing={6}>
    <McpUsageSummary companyId={companyId} />
    <McpUsageHistory companyId={companyId} />
  </Stack>
);

export { McpUsage };
